import axios from 'axios';


const request = axios.create({
    baseURL: '',
    timeout: 1000,
});

export const axiosService = {
    Get: (url, params) => {
        return request.get(url, params);
    }
}